import {
  Suspense, useEffect, useState,
} from 'react';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import { actions } from 'Slice/IndustriesSlice';
import IndustriesSvg from 'Components/layout/assets/IndustriesSvg';
import { useDispatch, useSelector } from 'react-redux';
import IndustriesSectionSkeleton from 'Components/industry/FullComponentSkeleton/IndustriesSectionSkeleton';
import RecommendedSectionSkeleton from 'Components/industry/FullComponentSkeleton/RecommendedSectionSkeleton';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { IsTablet } from 'Utils/UtilityFunctions';
import { selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import IndustriesSection from 'Components/industry/IndustriesSection';
import RecommendedSection from 'Components/industry/RecommendedSection';

const IndustriesHome = function IndustriesHome() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(actions.getIndustries());

    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
  }, []);

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  return (
    <>
      <NavBarPrimary headerClassName="headers-space box-shadow no-overflow-on-header">
        <div className="left-side-wrap">
          <IndustriesSvg />
          <h1 className="heading">Industries</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={IsTablet()} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>

      </NavBarPrimary>
      <div className="container">
        <Suspense
          fallback={
            <IndustriesSectionSkeleton />
          }
        >
          <IndustriesSection />
        </Suspense>
        <Suspense
          fallback={
            <RecommendedSectionSkeleton />
          }
        >
          <RecommendedSection />
        </Suspense>
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          disableDrop
          noButton
        />
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </>
  );
};

export default IndustriesHome;
